import { c as _c } from "react/compiler-runtime";
import { ResponsiveImage } from '@/app/components/media/app-image';
import { SPARTAN_PRODUCT_HERO_DESKTOP_COMPOSITION_MEDIA, SPARTAN_PRODUCT_HERO_DESKTOP_IMAGE_WIDTHS, SPARTAN_PRODUCT_HERO_MOBILE_COMPOSITION_MEDIA } from '@/app/lcv/components/sections/spartan/products/hero-banner/constants';
import type { SpartanProductHeroBannerParallaxLayerProps } from '@/app/lcv/components/sections/spartan/products/hero-banner/media/parallax-scene/layer/types';
import styles from '@/app/lcv/components/sections/spartan/products/hero-banner/media/parallax-scene/layout.module.css';
import { getSpartanProductHeroParallaxStyle } from '@/app/lcv/components/sections/spartan/products/hero-banner/utils/parallax-style';
import { getSpartanProductHeroBannerParallaxLayerLayoutStyle, getSpartanProductHeroBannerParallaxMediaSizes } from '@/app/lcv/components/sections/spartan/products/hero-banner/utils/scene-layout';
import { getSpartanParallaxProps } from '@/app/lcv/components/sections/spartan/products/shared/product-parallax-scroll';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const SpartanProductHeroBannerParallaxLayer = t0 => {
  const $ = _c(46);
  const {
    media,
    scene,
    layoutPrefix,
    className,
    testId,
    mediaTestId,
    isEntranceRevealEnabled: t1,
    isLcp: t2,
    loading,
    mobileWidths,
    desktopWidths,
    imageRef,
    onLoad,
    onError
  } = t0;
  const isEntranceRevealEnabled = t1 === undefined ? false : t1;
  const isLcp = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== media || $[1] !== scene) {
    t3 = getSpartanProductHeroBannerParallaxMediaSizes(media, scene);
    $[0] = media;
    $[1] = scene;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const sizes = t3;
  let t4;
  if ($[3] !== className || $[4] !== isEntranceRevealEnabled) {
    t4 = cn(className, {
      [styles.reveal]: isEntranceRevealEnabled
    });
    $[3] = className;
    $[4] = isEntranceRevealEnabled;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== layoutPrefix || $[7] !== media || $[8] !== scene) {
    t5 = getSpartanProductHeroBannerParallaxLayerLayoutStyle(media, scene, layoutPrefix);
    $[6] = layoutPrefix;
    $[7] = media;
    $[8] = scene;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== media.scrollSpeed) {
    t6 = getSpartanProductHeroParallaxStyle(media.scrollSpeed);
    $[10] = media.scrollSpeed;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = {
      ...t5,
      ...t6
    };
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== media.scrollSpeed) {
    t8 = getSpartanParallaxProps(media.scrollSpeed);
    $[15] = media.scrollSpeed;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== testId) {
    t9 = createDataAttributes({
      test: testId
    });
    $[17] = testId;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== isLcp || $[20] !== mobileWidths) {
    t10 = mobileWidths ?? (isLcp ? [640, 750, 828, 1080, 1280, 1440, 1680, 1920, 2048] : [1080, 1280, 1440, 1680, 1920, 2048]);
    $[19] = isLcp;
    $[20] = mobileWidths;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== media.mobile.src || $[23] !== sizes || $[24] !== t10) {
    t11 = {
      src: media.mobile.src,
      sizes,
      widths: t10,
      media: SPARTAN_PRODUCT_HERO_MOBILE_COMPOSITION_MEDIA
    };
    $[22] = media.mobile.src;
    $[23] = sizes;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = desktopWidths ?? SPARTAN_PRODUCT_HERO_DESKTOP_IMAGE_WIDTHS;
  let t13;
  if ($[26] !== media.desktop.src || $[27] !== sizes || $[28] !== t12) {
    t13 = {
      src: media.desktop.src,
      sizes,
      widths: t12,
      media: SPARTAN_PRODUCT_HERO_DESKTOP_COMPOSITION_MEDIA
    };
    $[26] = media.desktop.src;
    $[27] = sizes;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = isLcp ? "high" : undefined;
  const t15 = isLcp ? undefined : loading ?? "eager";
  let t16;
  if ($[30] !== imageRef || $[31] !== isLcp || $[32] !== mediaTestId || $[33] !== onError || $[34] !== onLoad || $[35] !== t11 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15) {
    t16 = <div className={styles.layerMedia}><ResponsiveImage mobileSrc={t11} desktopSrc={t13} alt="" fill={true} fade={false} preload={isLcp} fetchPriority={t14} loading={t15} objectFit="contain" objectPosition="bottom" testId={mediaTestId} imgRef={imageRef} onLoad={onLoad} onError={onError} /></div>;
    $[30] = imageRef;
    $[31] = isLcp;
    $[32] = mediaTestId;
    $[33] = onError;
    $[34] = onLoad;
    $[35] = t11;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t16 || $[41] !== t4 || $[42] !== t7 || $[43] !== t8 || $[44] !== t9) {
    t17 = <div aria-hidden="true" className={t4} style={t7} {...t8} {...t9}>{t16}</div>;
    $[40] = t16;
    $[41] = t4;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
};